import { render, staticRenderFns } from "./insurancePropertyTable.vue?vue&type=template&id=bfc22fd2&scoped=true"
import script from "./insurancePropertyTable.vue?vue&type=script&lang=js"
export * from "./insurancePropertyTable.vue?vue&type=script&lang=js"
import style0 from "./insurancePropertyTable.vue?vue&type=style&index=0&id=bfc22fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc22fd2",
  null
  
)

export default component.exports